// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrepaidCardProfilesController = function ($scope, PrepaidCardProfile, gettextCatalog, gettext) {
    $scope.prepaidCardProfiles = PrepaidCardProfile.query();

    function confirm(header, deleteCallback) {
        $scope.yesCancel(header, gettextCatalog.getString(gettext('Are you sure?')), function () { deleteCallback(); });
    }

    $scope.deleteProfile = function (profile) {
        confirm(gettextCatalog.getString(gettext('Delete Prepaid Card Profile')),
            function () {
                PrepaidCardProfile.remove({ Id: profile.Id }, function () {
                    location.reload();
                });
            });
    };
};
PrepaidCardProfilesController.$inject = ["$scope", 'PrepaidCardProfile', 'gettextCatalog', 'gettext'];
